import axios from 'axios';
import authHeader from './auth-header';

const API_URL = '/api/v2/';

class UserService {
    getCurrentUser(email) {
        return axios.get(API_URL + `current-user/${email}`, {headers: authHeader()})
            .then(response => {
                return response.data;
            });
    }

    getNotifications(email) {
        return axios.get(API_URL + `notifications/${email}`, {headers: authHeader()})
            .then(response => {
                return response.data;
            });
    }

    getCompletedCoursesCount(email) {
        return axios.get(API_URL + `completed-courses-count/${email}`, {headers: authHeader()})
            .then((response) => {
                if (response.data < 10) {
                    return "0" + response.data;
                } else {
                    return response.data;
                }
            })
    }

    getMembers() {
        return axios.get(API_URL + 'members', {headers: authHeader()});
    }

    getBusinesses() {
        return axios.get(API_URL + 'businesses', {headers: authHeader()});
    }

    getContacts() {
        return axios.get(API_URL + 'contacts', {headers: authHeader()});
    }

    getNewsletters() {
        return axios.get(API_URL + 'newsletters', {headers: authHeader()});
    }

    getEntityUsers() {
        return axios.get(API_URL + 'entities', {headers: authHeader()});
    }

    getPaths() {
        return axios.get(API_URL + 'paths', {headers: authHeader()});
    }

    sendEntityApplication(id) {
        return axios.get(API_URL + `entity-application/${id}`, {headers: authHeader()});
    }

    setIsAccepted(id) {
        return axios.get(API_URL + `is-accepted/${id}`, {headers: authHeader()});
    }

    updateMember(id, paths) {
        return axios.post(API_URL + `update-member/${id}`, paths, {headers: authHeader()});
    }
}

export default new UserService();
